module.exports = __webpack_public_path__ + "static/img/Fur.e7a22b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Fur.jpg
// module id = gZ2v
// module chunks = 1